module.exports = "/assets/data/ec4d122c5569093fc9420125c8bb62e1-GU16.data.json";